import { createNamespacedHelpers } from 'vuex'
import { APPLY } from '../interface/applybank'
import { merge } from 'lodash'

const initState = {
  guarantee: {},
  edit: {},
}

const mutations = {
  [APPLY.GUARANTEE](state, paylod) {
    state.guarantee = merge(state.guarantee, paylod)
  },
  [APPLY.CLEAR](state) {
    state.guarantee = {}
  },
  [APPLY.SET_EDIT_ID](state, id) {
    state.edit.id = id
  },
}

const { mapMutations, mapState } = createNamespacedHelpers('applybank')

export { mapMutations, mapState, APPLY }

export default {
  namespaced: true,
  state: initState,
  mutations: mutations,
}
